import general from "./general";
import medicine from "./medicine";
import test from "./test";
import certificate from "./certificate";
import product from "./product";
import technical from "./technical";
import personnel from "./personnel";
import lang from "../../lib/appfuse-react/core/lang";

const courseType = ['general', 'medicine', 'test', 'certificate', 'product', 'technical', 'personnel'];
const courseData = {general, medicine, test, certificate, product, technical, personnel};

const service = courseType.map((type) => ({
    matcher: `courseAnnouncement/${type}`,
    reply: config => {
        const {predicate} = config.params;
        let data;
        if(predicate?.node()?.selector?.()==='name') {
            const name = predicate.node().expectation();
            const regexp = new RegExp(name.replaceAll('*', '.*'));
            data = courseData[type].filter(course => regexp.test(course.name));
        } else {
            data = courseData[type];
        }
        return [200, data];
    }
}));

const courseAnnouncementService = [
    {
        matcher: /courseAnnouncement\/waiting\/(.*)/,
        reply: config => {
            const name = /courseAnnouncement\/waiting\/(.*)/.exec(config.url)[1];
            let result = []
            for(let data of courseType) {
                const value = courseData[data].filter(data => (data.name===name && data.enrollmentType==='waiting'));
                if(value) result = [...result, ...value];
            }
            return [200, result];
        }
    },
    {
        matcher: 'courseAnnouncement/all',
        reply: config => {
            const allData = Object.entries(courseData).map(data => data[1]);
            const data = [].concat.apply([], allData);
            return [200, data];
        }
    },
    ...service,
    {
        matcher: /courseAnnouncement\/(.*)/,
        reply: config => {
            const code = /courseAnnouncement\/(.*)/.exec(config.url)[1];
            for(let data of courseType) {
                const value = courseData[data].find(data => data.code===code);
                if(value) return [200, value];
            }
            return [200, {}];
        }
    }
]

export default courseAnnouncementService;